import { useMemo } from 'react';

import { useGlobalContext } from '@/context/global.context';

import { makeRoutesAbsolute, ROUTES_TRAMITE_RELATIVE } from '@/constants/routes.constants';
import { getUrlTramite } from '@/helpers/navigation';

const useRouteTramite = () => {
	const { getTramiteData, tramiteSeleccionado } = useGlobalContext();

	const path = useMemo(() => {
		const pathTramite = getUrlTramite(getTramiteData());
		const pathAbsolute = makeRoutesAbsolute<typeof ROUTES_TRAMITE_RELATIVE>(pathTramite, ROUTES_TRAMITE_RELATIVE);
		return pathAbsolute;
	}, [tramiteSeleccionado]);

	return path;
};

export default useRouteTramite;
